import { useState, useEffect } from "react";
import { useAuth } from "@/providers/AuthProvider";
import { useToast } from "@/components/ui/use-toast";
import { supabase } from "@/integrations/supabase/client";

export const useBusinessProfile = () => {
  const { user } = useAuth();
  const { toast } = useToast();
  const [businessProfile, setBusinessProfile] = useState<any>(null);

  useEffect(() => {
    const fetchBusinessProfile = async () => {
      if (user) {
        try {
          const {
            data,
            error
          } = await supabase.from('profiles').select('*').eq('id', user.id).single();
          if (error) {
            console.error("Error fetching business profile:", error);
            toast({
              title: "Error",
              description: "Failed to load business profile.",
              variant: "destructive"
            });
          } else if (data) {
            // Map database field names to expected format - PRESERVE ORIGINAL DATA
            const mappedProfile = {
              ...data,
              businessName: data.business_name || data.display_name || null,
              businessLogo: data.company_logo_url,
              phoneNumber: data.phone_number || data.phone,
              bankDetails: data.bank_details,
              // Keep original review_links and primary_review_link
              review_links: data.review_links,
              primary_review_link: data.primary_review_link
            };
            console.log("Loaded business profile with review data:", {
              review_links: mappedProfile.review_links,
              primary_review_link: mappedProfile.primary_review_link
            });
            setBusinessProfile(mappedProfile);
          }
        } catch (error) {
          console.error("Unexpected error fetching business profile:", error);
          toast({
            title: "Error",
            description: "Failed to load business profile.",
            variant: "destructive"
          });
        }
      }
    };
    fetchBusinessProfile();
  }, [user, toast]);

  return { businessProfile };
};
